import { ROTATE_CLOCKWISE } from '../actions/types';

export function updateRotation(rotations, pageIndex) {
  const newRotations = [...rotations];
  const page = newRotations.find(thisPage => thisPage.index === pageIndex);
  if (page) {
    page.degree += 90;
  } else {
    newRotations.push({
      index: pageIndex,
      degree: 90,
    });
  }
  // Sort order ASC
  return newRotations.sort((a, b) => a.index - b.index);
}

const rotations = (state = [], action = {}) => {
  switch (action.type) {
    case ROTATE_CLOCKWISE:
      return updateRotation(state, action.payload.pageIndex);
    default:
      return state;
  }
};

export default rotations;
